<template>
  <div
    class="u-16 around grid full-height cross-around hor-padding-20 active-time"
  >
    <div
      v-for="(time, index) in timeList"
      :key="index"
      class="u-16 grid cross-center"
    >
      <div
        v-for="(day, dayIndex) in chartData"
        :key="dayIndex"
        class="u hor-padding-10"
      >
        <div v-if="time == ''" class="ver-padding-5 text-center">
          {{ dayOfWeek(dayIndex) }}
        </div>
        <div
          v-else
          class="active-time-block grid center cross-center"
          :style="{
            backgroundColor:
              'rgba(255,163,114,' + opacityBlock(day, time) + ')',
          }"
        >
        </div>
      </div>
      <div class="u active-time_hours">{{ time }}</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VCharts from "v-charts";
Vue.use(VCharts);
export default {
  name: "chartActive",
  props: ["chartData"],
  data() {
    return {
      opacity: 0.1,
      timeList: [
        "0-3",
        "3-6",
        "6-9",
        "9-12",
        "12-15",
        "15-18",
        "18-21",
        "21-24",
        "",
      ],
      days: {
        mon: "пн",
        tue: "вт",
        wed: "ср",
        thu: "чт",
        fri: "пт",
        sat: "сб",
        sun: "вс",
      },
    };
  },

  methods: {
    opacityBlock(day, time) {
      return day && time
        ? Math.max(day[time].percent, this.opacity)
        : this.opacity;
    },
    countBlock(dayTime) {
      return dayTime ? dayTime.count : 0;
    },
    dayOfWeek(day) {
      return day ? this.days[day] : "—";
    },
    getCount(day, time) {
      return day && time ? day[time].count : 0;
    },
  },
};
</script>

<style lang="sass" scope>
.active-time
  padding-bottom: 30px
  font-size: 14px
  white-space: nowrap
.active-time-block
  border-radius: 7px
  background: #ffa372
  font-size: 12px
  height: 30px
  color: #cc7b50
.active-time_hours
  font-size: 13px
</style>
